import React, { useState } from 'react';
import { Card, CardBody, Collapse } from 'reactstrap';
import langText from '../../../../utils/langText';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import JobForm from './JobForm';
import api from '../../../../helpers/api';
import { Spinner } from 'react-bootstrap';
const CompanyBody = ({ data }) => {
  const [jobActive, setActiveJob] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [job, setJob] = useState(null);

  const toggleModal = () => setModal(!modal);
  const toggleConfirmModal = () => setConfirmModal(!modal);
  const toggle = () => setActiveJob(!jobActive);

  return (
    <>
      <a className='col-md-4 p-3 ' onClick={toggle}>
        <Card>
          <CardBody>
            <div
              className='d-flex justify-content-between'
              style={{ height: '30px' }}
            >
              {langText(data.businessName, data.businessNamei18n)}
              <div>{data.jobs.length}</div>
            </div>
            <Collapse isOpen={jobActive}>
              <h5 className='mt-3'>الوظائف</h5>
              <div className='d-flex flex-column align-items-center '>
                {data?.jobs?.map((job, index) => {
                  return (
                    <div className='d-flex align-items-center ' key={index}>
                      <a
                        className='pt-3 btn btn-link'
                        onClick={() => {
                          setJob(job);
                          toggleModal();
                        }}
                      >
                        {index + 1}- {job?.jobTitle}
                      </a>
                      <Button
                        color='transparent'
                        onClick={async () => {
                          setDeleteLoading(true);
                          try {
                            await api.delete(`/job/${job._id}`);
                            window.location.reload()
                          } catch (error) {
                          } finally {
                            setDeleteLoading(false);
                          }
                        }}
                      >
                        {deleteLoading ? (
                          <Spinner />
                        ) : (
                          <i
                            class='fas fa-trash-alt'
                            style={{ color: '#c70000' }}
                          ></i>
                        )}
                      </Button>
                    </div>
                  );
                })}
              </div>
            </Collapse>
          </CardBody>
        </Card>
      </a>
      {job && (
        <div>
          <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>{job?.jobTitle}</ModalHeader>
            <ModalBody>
              <JobForm jobData={job} toggleModal={toggleModal} />
            </ModalBody>
            <ModalFooter>
              <Button color='secondary' onClick={toggleModal}>
                الغاء
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </>
  );
};

export default CompanyBody;
